{
  "register-secret-data-page": {
    "buttons": {
      "back": "Retour",
      "submit": "Soumettre"
    },
    "text": {
      "login-data": "Vos données de connexion",
      "login-data-hint": "Vous devez définir vos données de connexion"
    }
  }
}
